import React from 'react';

export const TextAreaInput = props => {
	const { id, type, placeholder, className, label, value, error, disabled, changeAction, maxLength } = props;
	$(document).ready(function() {
		$(`textarea#${id}`).characterCounter();
	});
	return (
			<div className="input-textarea col s12">
				<label htmlFor={id}>{label}</label>
				<textarea
					className="materialize-textarea"
					id={id}
					value={value}
					onChange={changeAction || console.log("NOT IMPLEMENTED")}
					placeholder={placeholder}
					data-length={maxLength}
				/>
			</div>
	);
};


// WEBPACK FOOTER //
// src/atoms/lib/TextAreaInput.js